import React, { useState } from "react";
import { useForm } from "react-hook-form";
import PatientInfo from "./PatientInfo";
import AppointmentStep4 from "./Step4";

function AppointmentStep3() {
  const { handleSubmit } = useForm();
  const [showStepFour, setShowStepFour] = useState(false);

  const onSubmit = (data) => {
    //navigate("/Appointment/Step3")
    setShowStepFour((value) => !value);
  };

  if (showStepFour !== true) {
    return (
      <div className="row justify-content-md-center">
        <div className="appointmentBackground"></div>
        <div className="col col-lg-4">
          <h3 className="mt-5 mb-3">Questionnaire</h3>
          <div className="card pb-3 p-3 boxviewtransperant">
            <div className="card-body">
              <PatientInfo></PatientInfo>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <button
                      className="btn btn-secondary btn-block"
                      style={{ width: "100%" }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <AppointmentStep4 />;
  }
}

export default AppointmentStep3;
